<template>
  <div class="auth-modal">
    <!-- Modal Starts Here -->
    <div class="modal fade" id="joinCircleModal" tabindex="-1" role="dialog" aria-labelledby="joinCircleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content" v-if="circle">
          <div class="modal-header pb-0 border-0">
            <div>
                <h5 class="title my-0">Join {{circle.title}}</h5>
                <small class="text-muted">Join this circle by providing the required information</small>
            </div>
          </div>
          <div class="modal-body pt-3">
            <div class="row justify-content-center">
                <div class="col-12 mb-3">
                    <div class="row">
                        <div class="col-12 col-md-6" v-for="req of reqData" :key="req._id">
                            <div class="form-group">
                                <label :for="req.title">{{ req.title }}</label>
                                <input type="text" class="form-control" v-model="req.value" :name="req.title" :id="req.title" />
                            </div>
                        </div>
                    </div>
                    
                    <div class="mt-3 d-flex align-items-center justify-content-end" style="flex-wrap: wrap">
                        <button id="dismissBtnJoinCircle" @click="resetForm()" data-dismiss="modal" class="btn btn-light mr-2 my-1 btn-sm">Cancel</button>
                        <button id="joinCircleBtn" :disabled="!formValid" @click="submit()" class="btn btn-primary my-1 btn-sm">Join circle</button>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import CircleService from "@/services/circle";
    const circleService = new CircleService();

    export default {
        name: "JoinCircle",
        props: ["circle", "user"],
        data() {
            return {
                reqData: null,
            }
        },
        computed: {
            formValid: function(){
                let valid = false;
                if (this.reqData) {
                    valid = (this.reqData.find(s => (!s.value || s.value.length === 0))) ? false : true;
                }
                return valid;
            }
        },
        watch: {
            "$props.circle": {
                handler: function(val) {
                    if (val) {
                        const reqs = this.$props.circle.identities;
                        if (reqs) {
                            this.reqData = reqs.map(s => {
                                return { _id: s._id, title: s.title, value: null };
                            });
                        }
                    }
                },
                deep: true,
                immediate: true
            }
        },
        methods: {
            resetForm() {
                this.reqData.map(s => s.value = null);
            },
            submit() {
                const submitBtn = document.getElementById("joinCircleBtn");
                const dismissBtn = document.getElementById("dismissBtnJoinCircle");

                submitBtn.innerText = "Processing";
                submitBtn.disabled = true;
                submitBtn.classList.add("btn--loading");

                circleService.joinCircle(this.reqData, this.$props.circle._id, this.$props.user._id).then((board) => {
                    const circle = this.$props.circle;
                    if (circle.board) {
                        circle.board.push(board);
                    }
                    if (circle.boards) {
                        circle.boards.push(board);
                    }
                    circle.member_count += 1;

                    submitBtn.disabled = false;
                    submitBtn.innerText = "Join Circle";
                    submitBtn.classList.remove("btn--loading");

                    this.$notification.new(`You are now a member of ${circle.title}`);
                    dismissBtn.click();
                    this.$root.$emit("AddMemberToCircle", circle);
                    this.$root.$emit("JoinedCircle");
                }).catch(err => {
                    submitBtn.disabled = false;
                    submitBtn.innerText = "Join Circle";
                    submitBtn.classList.remove("btn--loading");
                    this.$root.$emit("ShowErrorNotification", err.message);
                })
            }
        },
        mounted() {
            const modal = document.getElementById("joinCircleModal");

            const disposeModal = function() {
                if (modal.style.display === 'none') {
                    this.resetForm.call(this);
                }
            };

            modal.addEventListener("blur", disposeModal.bind(this));
        }
    }
</script>

<style scoped lang="scss" src="../../Auth/AuthModal/AuthModal.scss"></style>